import React from 'react';
import PaidUtilityCyberTechPage from './productPages/PaidUtilityCyberTechPage';

export default function AiRebuildCyberTechPage() {
  return <PaidUtilityCyberTechPage productKey="image-toolkit-ai-rebuild" />;
}
